import { CourseStat } from "../../../../../models/state/courseStats";

export function getTotalStudyTime(
  state: CourseStat | null | undefined
): number {
  return state ? state.totalStudyTime : 0;
}

export function getScore(state: CourseStat | null | undefined): number {
  return state ? state.score : 0;
}

export function getSessionsCompleted(
  state: CourseStat | null | undefined
): number {
  return state ? state.sessionsCompleted : 0;
}

export function getNumberOfModulesStudied(
  state: CourseStat | null | undefined
): number {
  return state ? state.sessionModulesStudied : 0;
}

export function getProficiency(state: CourseStat | null | undefined): number {
  return state ? state.proficiency : 0;
}

export function getLastStudied(
  state: CourseStat | null | undefined
): string | null | undefined {
  return state ? state.lastStudied : null;
}
